module.exports = __webpack_public_path__ + "img/factoreseco.eb759326.png";